import { createFileRoute } from "@tanstack/react-router";

import type { WatchGameSessionViewViews } from "~/features/gameSession/components/GameSessionPlayerView/gameSessionPlayerViewTypes.ts";
import GameSessionDisplayPage from "~/pages/gameSession/GameSessionDisplayPage.tsx";

export const Route = createFileRoute("/_auth/game-session/$gameSessionId/")({
    validateSearch: (search: Record<string, unknown>): { view?: WatchGameSessionViewViews } => {
        return {
            view: (search.view as WatchGameSessionViewViews) || "stats",
        };
    },
    component: GameSessionDisplayPage,
});
